import { useEntity } from "@backstage/plugin-catalog-react";
import Grid from "@mui/material/Grid";
import { EntityArgoCDHistoryCard } from "@roadiehq/backstage-plugin-argo-cd";
import React from "react";

export const CDContent = () => {
	const { entity } = useEntity();
	const hasArgoCDAnnotation =
		entity.metadata.annotations?.["argocd/app-selector"];

	if (!hasArgoCDAnnotation) {
		return null;
	}

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<EntityArgoCDHistoryCard />
			</Grid>
		</Grid>
	);
};

export const cdContent = <CDContent />;
